"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.EnvironmentTypes = void 0;
var EnvironmentTypes;
/**
 * Fallback to get the environment based on the hostname
 *
 * @returns {Environment} - The environment based on the hostname
 */

exports.EnvironmentTypes = EnvironmentTypes;

(function (EnvironmentTypes) {
  EnvironmentTypes["DEVELOPMENT"] = "development";
  EnvironmentTypes["STAGING"] = "staging";
  EnvironmentTypes["PRODUCTION"] = "production";
})(EnvironmentTypes || (exports.EnvironmentTypes = EnvironmentTypes = {}));

var getEnvironmentByHostname = function getEnvironmentByHostname() {
  var hostname = typeof window !== 'undefined' && window.location && window.location.hostname || '';

  switch (hostname.toLowerCase()) {
    // Commented out for now because it messes with tests
    case 'localhost':
      return EnvironmentTypes.DEVELOPMENT;

    case 'qa.zola.com':
    case 'qa-homestore.zola.com':
      return EnvironmentTypes.STAGING;

    case 'www.zola.com':
    case 'zola.com':
    case 'homestore.zola.com':
      return EnvironmentTypes.PRODUCTION;

    default:
      return EnvironmentTypes.PRODUCTION;
  }
};
/**
 * Gets the environment based on the hostname or zola environment.
 *
 * @memberof client
 *
 * @returns {EnvironmentTypes} - the environment
 */


var _default = function _default() {
  var _window, _window$zola;

  var zolaEnv = (typeof window !== 'undefined' ? (_window = window) === null || _window === void 0 ? void 0 : (_window$zola = _window.zola) === null || _window$zola === void 0 ? void 0 : _window$zola.env : process.env.NODE_ENV) || getEnvironmentByHostname();

  switch (zolaEnv) {
    case 'development':
    case 'dev':
      return EnvironmentTypes.DEVELOPMENT;

    case 'staging':
    case 'stage':
      return EnvironmentTypes.STAGING;

    case 'production':
    case 'prod':
      return EnvironmentTypes.PRODUCTION;

    default:
      return EnvironmentTypes.PRODUCTION;
  }
};

exports.default = _default;